export default "__VITE_ASSET__BEuYkvJy__"